export function createXLSheetdata(kitchenList) {
    kitchenList.find((ticketDetails, index) => {
                
            kitchenList[index].Kitchen_Name=kitchenList[index].kitchen_name
            delete kitchenList[index]['kitchen_name']

            kitchenList[index].Kitchen_Code=kitchenList[index].kitchen_code
            delete kitchenList[index]['kitchen_code']
            
            kitchenList[index].Kitchen_Manager=kitchenList[index].kitchen_manager_name
            delete kitchenList[index]['kitchen_manager_name']
                   
            delete kitchenList[index]['id']         
            delete kitchenList[index]['stores']         
            
            kitchenList[index].Cluster_Name=kitchenList[index].cluster_name
            delete kitchenList[index]['cluster_name']
            
            kitchenList[index].Cluster_Manager_Name=kitchenList[index].cluster_manager_name
            delete kitchenList[index]['cluster_manager_name']
            
            kitchenList[index].City_Name=kitchenList[index].city_name
            delete kitchenList[index]['city_name']
            
            kitchenList[index].Location=kitchenList[index].location
            delete kitchenList[index]['location']
            
            kitchenList[index].Status=kitchenList[index].status
            delete kitchenList[index]['status']
        

                return false
            })   
            return kitchenList
}





// WEBPACK FOOTER //
// ./src/modules/Kitchens/services/helpers.js